import React, { useEffect, useState } from "react";
import "./migrantesCard.scss";
import TitleSection from "../../molecules/title-section";
import ProgressBarAceleradora from "../../atoms/progress-bar-aceleradora/progressBarAceleradora";
import { getFormData, saveForm, getToken } from "../../../services/formServices";
import FormBodyMigrantes from "../form-body-migrantes/FormBodyMigrantes";
import { getMunicipalities } from "../../../services/municipalities";
import rawToReact from "../../../utils/rawToReact";
import Modal from "../../molecules/modal/modal";
import FormModal from "../../ui/modal/Modal";
import { navigate } from "gatsby";
import Button from "../../atoms/button/button";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import moment from "moment";

type MigrantesCardProps = {
    tituloPrincipal?: string;
    tituloFormulario?: string;
    descripcionFormulario?: any;
    tituloUbicacion?: string;
    titulosFormulario: Array<any>;
    metaTitulo: string;
    modalSuccess: any;
    modalRegistered: any;
    modalCancelar: any;
    modalDeshabilitar: any;
    pathSharepoint?: string;
    modalEdad: any;
};

interface IModalContent {
    title: string;
    image: string;
    textButton: string;
    url: string;
    textOptionalButton: string;
    urlOptional: string;
}


function MigrantesCard(props: MigrantesCardProps) {

    const defaultFormValues = {
        docNumber: [],
        registerDate: "",
        birth_date: ""
     }


    const [formValues, setFormValues] = useState(defaultFormValues);
    // cuando se renderiza el grupo todos los inputs obligatorios son agregados a una lista
    const [wizards, setWizards] = useState<any[]>([]);
    const [isDisabledButton, setDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [fieldsToSkip, setFieldsToSkip]= useState<string[]>([]);
    const [continueFormRegistered, setContinueFormRegistered] = useState(true);
    const [cancelForm, setCancelForm] = useState(false);
    const [authorizationMigFormP, setAuthorizationMigFormP] = useState(false);
    const [authorizationMigFormI, setAuthorizationMigFormI] = useState(false);
    const ID_ANTIOQUIA = 1;
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<IModalContent>();
    const [isError, setIsError] = useState<boolean>(false);
    const [otherNationality, setOtherNationality] = useState(false);
    const [disabilityName, setDisabilityName] = useState(false);
    const [whichPreviousProgram, setWhichPreviousProgram] = useState(false);
    const [flagModalRegistrado, setFlagModalRegistrado] = useState(false);
    const [displayModalEdad, setDisplayModalEdad] = useState(true);

    const contentfulModalSuccess = props.modalSuccess;
    const contentfulModalRegistered = props.modalRegistered;
    const registerDate = moment(Date.now()).format('DD-MM-YYYY');
    
    const changeDisplayElement = (selector: string, displayType: string) => {
        if (document.querySelector(selector)) {
            document.querySelector(selector).style.display = displayType;
        }
    };

    const handleCancel = () =>{
        setCancelForm(true);
    }

    const handleAuthorizationMigP = () =>{
        setAuthorizationMigFormP(true);
    }

    const handleAuthorizationMigI = () =>{
        setAuthorizationMigFormI(true);
    }

    const closeCancelForm = () => {
        setCancelForm(false);
        setAuthorizationMigFormP(false);
        setAuthorizationMigFormI(false);
    };

    // Crea lista de los titulos para el wizard
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < props.titulosFormulario.length; i++) {
            if (props.titulosFormulario[i]) {
                newWizards.push({
                    description: props.titulosFormulario[i].tituloGeneral,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    // Estado para determinar el titulo activo del wizard
    useEffect(() => {
        createWizards();
    }, []);

    //Validaciones para los inputs
    const inputRegexValidation = (field: any, value: any) => {
        // Evita que el usuario incluya caracteres no alfabeticos
        if (field === "nameContact" || field === "role") {
            const re = /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g;
            return re.test(value);
        } else if (field === "phone") {
            return value.length <= 10 ? true : false;
        }
        return true;
    };

    const resetFormValues = (key: string, selector: string) => {
        setFormValues((prev:any) => {
            const auxFormValues = { ...prev };
            delete auxFormValues[key];
            return auxFormValues;
        });
        const inputSel =  document.querySelector(selector) || {};
        inputSel.value = "";
    };

    const updateInputValue = (field: string, value: any, type?: string, e?: any) => {
        setFormValues({ ...formValues, ["registerDate"]: registerDate});

        let currentDate = new Date();
        if (field == "birth_date"){
            if((currentDate.getFullYear() - value.split('-')[2]) <= 17){
                setDisplayModalEdad(false);
            }
        }

        if (inputRegexValidation(field, value)) {
            setFormValues((prev: any) => {
                return { ...prev, [field]: value };
            });
        }

        if (field == "nationality"){
            if(value === "Otra") {
                changeDisplayElement(".a-input-aceleradora__form-otherNationality", "block");
                changeDisplayElement(".a-input-aceleradora__form-venezuelanDocNumber", "none");
                setOtherNationality(true);
            } else {
                changeDisplayElement(".a-input-aceleradora__form-otherNationality", "none");
                resetFormValues("otherNationality", "#input-otherNationality");
                setOtherNationality(false);
            }

            if(value === "Venezolana") {
                changeDisplayElement(".a-input-aceleradora__form-venezuelanDocNumber", "block");
            } else {
                changeDisplayElement(".a-input-aceleradora__form-venezuelanDocNumber", "none");
                resetFormValues("venezuelanDocNumber", "#input-venezuelanDocNumber");
                fieldsToSkip.push("venezuelanDocNumber");
            }
        }

        if (field == "disability"){
            if(value === "No") {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "none");
                setDisabilityName(false);
            } else {
                changeDisplayElement(".a-input-aceleradora__form-disabilityName", "block");
                setDisabilityName(true);
            }
        }        

        if (field == "withPreviousParticipation"){
            if(value === "Sí") {
                changeDisplayElement(".a-input-aceleradora__form-whichPreviousProgram", "block");
                setWhichPreviousProgram(true);
            } else {
                changeDisplayElement(".a-input-aceleradora__form-whichPreviousProgram", "none");
                setWhichPreviousProgram(false);
            }
        }

        Object.entries(formValues).forEach(([key, value]) => {
            if (`${key}` === "birth_date"){
                if((currentDate.getFullYear() - `${value.split('-')[2]}`) <= 29){
                    changeDisplayElement(".a-input-aceleradora__form-trainingInterest", "block");
                } else {
                    changeDisplayElement(".a-input-aceleradora__form-trainingInterest", "none");
                }
            }            
        });

        setFieldsToSkip(fieldsToSkip);
    };   
    
    const createPayload = () => {
        const payload: any = {
            idForm: 13,
            answers: [],
        };

        // Delete key/values skipped from formValues
        fieldsToSkip.forEach(field => delete formValues[field]);

        Object.entries(formValues).forEach(([key, value]) => {
            payload.answers.push({ contentfulId: key, answer: value });
        });
        return payload;
    };

    const handleSubmitForm = async () => {
        
        setDisabledButton(true);
        const payload = createPayload();

        payload.answers.forEach((answer) => {
            if (!otherNationality && answer["contentfulId"] == "otherNationality") {
                answer["answer"] = "";
            }

            if (!disabilityName && answer["contentfulId"] == "disabilityName") {
                answer["answer"] = "";
            }

            if (!whichPreviousProgram && answer["contentfulId"] == "whichPreviousProgram") {
                answer["answer"] = "";
            }
        });

        const token = await getToken(null);
        const response = await saveForm(payload, token);
        
        handleModalContent(response.data.status);
        setIsOpenModal(true);
        setDisabledButton(false);
    };

    // cuando se renderiza el grupo todos los inputs obligatorios son agregados a una lista
    const createInputGroupRequiredList = () => {
        const inputList: any = [];
        props.titulosFormulario.forEach((tituloFormulario) => {
            tituloFormulario.referenciaFormulario.forEach((input) => {
                if (input.obligatorio) {
                    inputList.push(input.nombreId);
                }
            });
        });
        return inputList;
    };

    const municipalitiesList = async () => {
        try {
            setDisabledButton(true);
            const data = await getMunicipalities(ID_ANTIOQUIA);
            const municipalities = [];
            Object.entries(data.data.data).forEach(([key, value]) => {
                municipalities.push(value.name);
            });

            municipalities.sort();
            // Agrega los municipalities como options al campo de tipo select correspondiente
            Object.entries(
                props.titulosFormulario[2].referenciaFormulario
            ).forEach(([key, value]) => {
                if (value.nombreId === "municipalities") {
                    props.titulosFormulario[2].referenciaFormulario[
                        key
                    ].listaSelect = municipalities;
                }
            });
            setDisabledButton(false);
        } catch (error) {
            console.log("API Error:", error);
        }
    };

    const handleClickNext = async () => {
        const token = await getToken(null);
        const request = await getFormData(13, token);
        let flagRegistered = false;
        request.data.forEach((docNumberData) => {
            const item = docNumberData.answerData;
            let flagDocNumber = false;
            let flagDocType = false;

            Object.entries(formValues).forEach(([key, value]) => {
                if (`${key}` === "document_type"){
                    if (`${value}` === item.document_type){
                        flagDocType = true
                    }
                }

                if (`${key}` === "docNumber"){
                    if (`${value}` === item.docNumber){
                        flagDocNumber = true;
                    }
                }

                if (flagDocType && flagDocNumber){
                    if(new Date(docNumberData.creationDate) >= new Date(props.modalDeshabilitar.fechaInicioConvocatoriaMigrantes)){
                        flagRegistered = true;
                        setContinueFormRegistered(false);
                        setModalContent({
                            title: props.modalRegistered.tituloPrincipal,
                            image: props.modalRegistered.imagenFormulario.file.url,
                            textButton: props.modalRegistered.tituloBoton,
                            url: props.modalRegistered.redireccionBoton,
                            textOptionalButton: props.modalRegistered.tituloBotonOpcional,
                            urlOptional: props.modalRegistered.redireccionBotonOpcional,
                        });
                    }
                }
            });
        });
        
        return flagRegistered;
    }

    useEffect(() => {
        municipalitiesList();
        handleClickNext(); 
    }, []);

    // Guarda en un estado con el contenido de los modales que se renderizan al finalizar el formulario
    const handleModalContent = (status: number) => {
        if (status === 200) {
            setFlagModalRegistrado(true);
            setModalContent({
                title: props.modalSuccess.tituloPrincipal,
                image: props.modalSuccess.imagenFormulario.file.url,
                textButton: props.modalSuccess.tituloBoton,
                url: props.modalSuccess.redireccionBoton,
                textOptionalButton: props.modalSuccess.tituloBotonOpcional,
                urlOptional: props.modalSuccess.redireccionBotonOpcional,
            });
            setIsError(false);
        }
    };

    // Retorna el contenido de un modal dependiendo del resultado al completar un formulario
    const getContentModal = () => {
        // Si hay error al completar el formulario se renderiza el contenido del modal no exitoso
        if (!isError) {
            // Si se completa el formulario se renderiza el contenido del modal exitoso
            return (
                <p>
                    {rawToReact(
                        contentfulModalSuccess.descripcionFormulario.raw,
                        contentfulRenderOptions
                    )}
                </p>
            );
        }
    };

    const closeForm = () => {
        navigate(props.modalCancelar.redireccionBotonOpcional);
    };

    const closeModalEdad = () => {
        setDisplayModalEdad(true);
        setFormValues({ ...formValues, ["birth_date"]: ""});

        return false;
    };

    return (
        <div className={`m-migrantes-card${isOpenModal ? "__successModal" : ""}`}>
            {/* Renderiza el modal */}
            {!isOpenModal && (
                <>
                <div className="m-migrantes-card__header">
                    <TitleSection title={props.tituloPrincipal} />
                    <p className="m-subtitle-section">
                        {props.descripcionFormulario && (
                            contentfulRenderOptions(
                                props.descripcionFormulario,
                            )
                        )}
                    </p>
                    {/* Renderiza la barra de progreso del formulario */}
                    <ProgressBarAceleradora
                        formValues={formValues}
                        requiredValues={createInputGroupRequiredList()}
                        fieldsToSkip={fieldsToSkip}
                    ></ProgressBarAceleradora>
                </div>
                <div className="m-migrantes-card__body">
                    <div className="m-migrantes-card__body__content">
                        <FormBodyMigrantes
                            // Campos y estilos del formulario
                            titulosFormulario={props.titulosFormulario}
                            genericClassNameForm={props.metaTitulo}
                            setInputValue={updateInputValue}
                            formValues={formValues}
                            handleSubmitForm={handleSubmitForm}
                            inputDisabled={inputDisabled}
                            isDisabledButton={isDisabledButton}
                            handleEvent={handleClickNext}
                            fieldsToSkip={fieldsToSkip}
                            handleCancelButton={handleCancel}
                            handleAuthorizationMigP={handleAuthorizationMigP}
                            handleAuthorizationMigI={handleAuthorizationMigI}
                            modalDeshabiltar={props.modalDeshabilitar}
                        >
                            {cancelForm && (
                             <FormModal
                             showModal={cancelForm}
                             onClose={closeCancelForm}>
                                 <div
                                     className={`m-modal-container-validation`}
                                 >
                                     <h3>{props.modalCancelar.tituloPrincipal}</h3>
                                     
                                     <div className="a-button-magenta-container__modal-cancelar">
                                         <Button
                                            type="button"
                                            classname="a-button-magenta"
                                            text={props.modalCancelar.tituloBoton} 
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeCancelForm()
                                            }}
                                         >
                                         </Button>
                                     </div>
                                     <div>
                                     
                                     <Button
                                            type="button"
                                            classname="m-modal-content__buttonbar__cancel"
                                            text={props.modalCancelar.tituloBotonOpcional} 
                                            isDisabled={false}
                                            onClickAction={() => {
                                                closeForm()
                                            }}
                                            >
                                    </Button>
                                     </div>
                                 </div>
                            </FormModal>
                            )}

                            {authorizationMigFormP && (
                                <FormModal
                                showModal={authorizationMigFormP}
                                onClose={closeCancelForm}>
                                    <div className={`m-modal-container-authorization`}>
                                        <p>
                                            {/* renderiza los terminos para la autorizacion de datos. */}
                                            {rawToReact(
                                                props.titulosFormulario[0].referenciaFormulario[1].textoTerminosMigrantes.raw,
                                                contentfulRenderOptions
                                            )}
                                        </p>
                                    </div>
                                </FormModal>
                            )}

                            {authorizationMigFormI && (
                                <FormModal
                                showModal={authorizationMigFormI}
                                onClose={closeCancelForm}>
                                    <div className={`m-modal-container-authorization`}>
                                        <p>
                                            {/* renderiza los terminos para la autorizacion de datos. */}
                                            {rawToReact(
                                                props.titulosFormulario[0].referenciaFormulario[2].textoTerminosMigrantes.raw,
                                                contentfulRenderOptions
                                            )}
                                        </p>
                                    </div>
                                </FormModal>
                            )}
                        </FormBodyMigrantes>
                    </div>
                </div>
                </>
            )}
            {/* Renderiza el modal para el registro exitoso */}
            {isOpenModal && (
                <Modal
                    image={modalContent?.image ? modalContent.image : ""}
                    title={modalContent?.title ? modalContent.title : ""}
                    textButton={
                        modalContent?.textButton ? modalContent.textButton : ""
                    }
                    url={modalContent?.url ? modalContent.url : ""}
                >
                    <div className="m-migrantes-card__content-modale">
                        {getContentModal()}
                    </div>
                </Modal>
            )}

            {/* Renderiza el modal si ya esta registrado */}
            {!continueFormRegistered && !flagModalRegistrado && (
                <FormModal showModal={!continueFormRegistered} onClose={closeForm}>
                <div className="m-modal-content">
                    <div className="m-modal-content__form">
                        <div className="m-modal-content__form__title">
                            {modalContent.title}
                        </div>
                        <div className="m-modal-content__form__descr">
                            <p>
                                {rawToReact(
                                    contentfulModalRegistered.descripcionFormulario.raw,
                                    contentfulRenderOptions
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="m-modal-content__buttonbar">
                        <Button
                            type="link"
                            text={modalContent?.textButton}
                            classname={"m-modal-content__buttonbar__back"}
                            isDisabled={false}
                            href={modalContent?.url ? modalContent.url : ""}
                        />
                    </div>
                </div>
                </FormModal>
            )}

            {/* Renderiza el modal de validacion de edad, que solo se muestra en el segundo paso */}
            {!displayModalEdad && (
                <FormModal showModal={displayModalEdad} onClose={closeModalEdad}>
                    <div className="m-modal-content">
                        <div className="m-modal-content__form">
                            <img className="m-modal__image" 
                                src={props.modalEdad.imagenFormulario.file.url}
                                alt={props.modalEdad.tituloPrincipal} />
                            <div className="m-modal-content__form__title">
                                {props.modalEdad.tituloPrincipal}
                            </div>
                            <div className="m-modal-content__form__recuerda">
                                <p>
                                    {rawToReact(props.modalEdad.descripcion.raw, contentfulRenderOptions)}
                                </p>
                            </div>
                        </div>
                        <div className="m-modal-content__buttonbar">
                            <Button
                                type="link"
                                text={props.modalEdad?.tituloBoton}
                                classname={"m-modal-content__buttonbar__back"}
                                isDisabled={false}
                                onClickAction={closeModalEdad}
                            />
                        </div>
                    </div>
                </FormModal>
            )}
        </div>
    );
}

export default MigrantesCard;
